module.exports = __webpack_public_path__ + "static/media/IMG_1513.a77acc05.JPG";